export function isValidConnectionName(name: string) {
  return /^[a-z0-9][a-z0-9\-_]{1,48}[a-z0-9]$/g.test(name)
}
